import { render, staticRenderFns } from "./ActiveSessions.vue?vue&type=template&id=64e58054&scoped=true"
import script from "./ActiveSessions.vue?vue&type=script&lang=js"
export * from "./ActiveSessions.vue?vue&type=script&lang=js"
import style0 from "./ActiveSessions.vue?vue&type=style&index=0&id=64e58054&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e58054",
  null
  
)

export default component.exports